import { apiClient } from './index';
export type AgentRunState = 'queued' | 'running' | 'review' | 'accepted' | 'rejected' | 'failed' | 'cancelled' | 'expired';
export interface AgentRun {
  id: string; task_id: string; requested_by: string; requested_scope: string; acceptance_criteria: string;
  state: AgentRunState; worker_user_id?: string; worker_channel?: string; worker_client_id?: string; agent_name?: string;
  attempt: number; max_attempts: number; updates: number; max_updates: number; deadline: string;
  summary: string; evidence_url?: string; reviewed_by?: string; review_note?: string; created_at: string; updated_at: string;
}
export interface AgentRunEvent {
  id: string; actor_id: string; auth_channel: string; auth_client_id?: string; action: string;
  from_state: string; to_state: string; summary: string; evidence_url?: string; created_at: string;
}
export interface RequestAgentRun {
  request_id: string; requested_scope: string; acceptance_criteria: string; max_attempts: number; max_updates: number; deadline_minutes: number;
}
export async function listAgentRuns(taskID: string): Promise<AgentRun[]> {
  return (await apiClient.get<{ data: AgentRun[] }>(`/tasks/${taskID}/agent-runs`)).data.data;
}
export async function requestAgentRun(taskID: string, input: RequestAgentRun): Promise<AgentRun> {
  return (await apiClient.post<{ data: AgentRun }>(`/tasks/${taskID}/agent-runs`, input)).data.data;
}
export async function reviewAgentRun(taskID: string, runID: string, action: 'accept' | 'reject' | 'cancel' | 'retry', summary: string, requestID: string): Promise<AgentRun> {
  return (await apiClient.post<{ data: AgentRun }>(`/tasks/${taskID}/agent-runs/${runID}`, { action, summary, request_id: requestID })).data.data;
}
export async function agentRunEvents(taskID: string, runID: string): Promise<AgentRunEvent[]> {
  return (await apiClient.get<{ data: AgentRunEvent[] }>(`/tasks/${taskID}/agent-runs/${runID}/events`)).data.data;
}
